import {
  Create,
  SimpleForm,
  Toolbar,
  SaveButton,
  useTranslate,
  useRedirect,
  useNotify,
} from 'react-admin';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { PlaybookForm } from './PlaybookForm';
import { transformPlaybook } from './playbookFormHelpers';

const CreateToolbar = () => (
  <Toolbar sx={{ backgroundColor: '#FAFAFA', borderTop: '1px solid #E0E0E0', px: { xs: 2, sm: 3 }, py: 2 }}>
    <SaveButton variant="contained" />
  </Toolbar>
);

const PageHeader = () => {
  const redirect = useRedirect();
  const translate = useTranslate();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 }, mb: { xs: 2, sm: 4 } }}>
      <IconButton
        onClick={() => redirect('list', 'ai-playbooks')}
        size="large"
        sx={{ backgroundColor: '#FFFFFF', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
        title={translate('resources.ai-playbooks.create.backToList')}
      >
        <ArrowBack />
      </IconButton>
      <Box>
        <Typography sx={{ fontWeight: 600, mb: 0.5, fontSize: { xs: '1.25rem', sm: '2.125rem' } }}>
          {translate('resources.ai-playbooks.create.title')}
        </Typography>
        <Typography sx={{ fontSize: { xs: '0.75rem', sm: '1rem' } }} color="text.secondary">
          {translate('resources.ai-playbooks.create.subtitle')}
        </Typography>
      </Box>
    </Box>
  );
};

// Manual hand-authoring of a playbook (not only via promote). The transform JSON-parses the two
// JSON inputs and strips read-only fields before the dataProvider POSTs.
export const PlaybookCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      title={false}
      component="div"
      redirect="list"
      mutationMode="pessimistic"
      transform={transformPlaybook}
      mutationOptions={{
        onSuccess: () => {
          notify('resources.ai-playbooks.notifications.created', { type: 'success' });
          redirect('list', 'ai-playbooks');
        },
        onError: () => {
          notify('resources.ai-playbooks.notifications.error.create', { type: 'error' });
        },
      }}
    >
      <SimpleForm toolbar={<CreateToolbar />}>
        <Box sx={{ width: '100%' }}>
          <PageHeader />
          <PlaybookForm />
        </Box>
      </SimpleForm>
    </Create>
  );
};

export default PlaybookCreate;
